import { orchestrator } from 'satcheljs';
import { updateCalendarIds } from '../actions/publicActions';
import { updateCalendarIds as updateCalendarIdsAction } from 'owa-calendar-events-loader';
import { updateUpNextCalendarIds } from 'owa-upnext-event-loader';
import {
    getScenarioUpNextCacheId,
    getScenarioListCacheId,
} from '../selectors/agendaStoreSelectors';

export const updateCalendarIdsOrchestrator = orchestrator(updateCalendarIds, actionMessage => {
    const { calendarIds, scenarioId } = actionMessage;

    updateCalendarIdsAction(calendarIds, getScenarioListCacheId(scenarioId));
    updateUpNextCalendarIds(calendarIds, getScenarioUpNextCacheId(scenarioId));
});
